import { PanelContainer } from './PanelContainer';
import { createElement } from './utils';

/** @brief Special smaller {@link PanelContainer} holding some panels. Display triggered by clicking "cogwheel" icon.
 * @extends {PanelContainer}
 */
class SettingsBox extends PanelContainer {
    /** @brief Element holding button used to open dialog ("cogwheel"). */
    protected settingsImg: HTMLElement;

    /** @brief Creates an instance of SettingsBox.
     * @param   {HTMLElement} parentElement Element to which to append container element.
     * @param   {string} baseClass Class prefix for element.
     */
    constructor(parentElement: HTMLElement, baseClass: string, backgroundClass: string) {
        super(parentElement, baseClass, backgroundClass);

        this.enableShadow = true;

        this.shadow.onclick = this.hideDialog.bind(this);

        // button to open the dialog
        this.settingsImg = createElement(this.container, "i", 'rvi rvi-cogwheel');
        this.container.onclick = this.showDialog.bind(this);

        this.hideDialog(); // content is shown by default in PanelContainer, but it should be hidden for SettingsBox
        this.parentElement.appendChild(this.content);
    }

    /** @brief Shows both triggering icon and dialog. */
    override show() : this {
        return super.show();
    }

    /** @brief Hides both triggering icon and dialog. */
    override hide() : this {
        return super.show();
    }

    /** @brief Shows dialog only. */
    showDialog() : void {
        this.content.classList.remove("hidden");
        this._createShadow(this.content);
    }

    /** @brief Hides dialog only. */
    hideDialog() : void {
        this._destroyShadow();
        this.content.classList.add("hidden"); // hide the dialog
        this.disableTemporaryMode();
    }
}

export { SettingsBox };
